import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

type Target =
  | ents.core.agent.KnowledgeBase.Target.Tenant
  | ents.core.agent.KnowledgeBase.Target.Zone
  | ents.core.agent.KnowledgeBase.Target.Record

/** Converts an Admin-managed availability target into its GraphQL input. */
export const TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    Target,
    graphql.schema.AdminAgentKnowledgeBaseManagementTargetInput
  >({
    modelId: target =>
      ents.core.agent.KnowledgeBase.Target.Record.isRecord(target)
        ? target.modelId
        : undefined,
    recordId: target =>
      ents.core.agent.KnowledgeBase.Target.Record.isRecord(target)
        ? target.recordId
        : undefined,
    tenantId: target => target.tenantId,
    zoneId: target =>
      ents.core.agent.KnowledgeBase.Target.Zone.isZone(target) ||
      ents.core.agent.KnowledgeBase.Target.Record.isRecord(target)
        ? target.zoneId
        : undefined,
  }),
)
